// extracted by mini-css-extract-plugin
module.exports = {"appStores":"AppStores_appStores__3LMUb","link":"AppStores_link__2qW0x"};